import React from 'react';
import { useLiveRegion } from 'src/hooks/accessibility';
import { PandaChatProviderBase } from 'shared/panda/chat/panda-chat-provider';
import { usePandaChatPersistence } from 'shared/panda/chat/panda-chat-persistence.hooks';
import { createPandaAgent } from './panda-agent';
import { pandaAnalytics } from './panda-analytics';

export { usePandaConversation } from 'shared/panda/chat/panda-chat-provider';

export function PandaChatProvider({ children }: { children: React.ReactNode }) {
  // Settled runs are persisted so a remounted provider reseeds the chat from
  // its committed history.
  const { committedMessages, persistMessages } = usePandaChatPersistence();
  const { announce, liveRegion } = useLiveRegion({ 'aria-live': 'assertive' });

  return (
    <PandaChatProviderBase
      createAgent={createPandaAgent}
      analytics={pandaAnalytics}
      initialMessages={committedMessages}
      onRunSettled={persistMessages}
      onError={announce}>
      {children}
      {liveRegion}
    </PandaChatProviderBase>
  );
}
